module.exports = __webpack_public_path__ + "img/H2.d83acce9.png";